<template name="addNewMemberForRead">
  <div>
    <div>
      <div style="display: flex;justify-content: center;">
        <el-input style="width: 60%;margin-right: 10px"
                  placeholder="请输入用户名关键字"
                  v-model="searchTxt" @clear="clear"
                  clearable>
        </el-input>
        <el-button icon="el-icon-search" circle @click="getCompanyUserList"></el-button>
      </div>

      <div v-if="flag == 0">
        <el-table :data="searchList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="nickname" label="用户名" width="580" show-overflow-tooltip align="center"/>
          <el-table-column fixed="right" label="分配页面" min-width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-edit" type="primary" circle @click="addMemberForPermission(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div v-if="flag == 1">
        <el-table :data="nameList" style="width: 100%;text-align: center; height: 100%; " border ref="refTable"
                  :header-cell-style="{ background: '#F2F2F2', color: '#333' }">
          <el-table-column prop="nickname" label="用户名" width="580" show-overflow-tooltip align="center"/>
          <el-table-column fixed="right" label="分配页面" min-width="110" show-overflow-tooltip align="center">
            <template v-slot="scope">
              <el-button icon="el-icon-edit" type="primary" circle @click="addMemberForPermission(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="button-group-card2">
      <div class="button-group-title2">
        <el-button type="primary" @click="returnBack" :plain="true">返回有权限用户列表</el-button>
      </div>
    </div>
    <el-dialog
        title="提示"
        :visible.sync="addMemberForPermissionDialogVisible"
        width="30%"
    >
      <span>确定新增权限？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMemberForPermissionDialogVisible=false;">取 消</el-button>
        <el-button type="primary" @click="handleAddMemberForPermission">确 定</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/../config/api.js";

export default {
  name: "addNewMemberForRead",
  props: {
    companyId: Number,
    productId: Number,
  },
  data() {
    return {
      searchTxt: '',
      projectId: '',
      nameList: [],
      pageNum: 1,
      pages: '',
      searchPageNum: 1,
      searchPages: '',
      searchList: [],
      flag: 1,
      userId: '',
      addMemberForPermissionDialogVisible: false,
      addMemberForPermissionItem: {},
    }
  },
  mounted() {
    this.userId = window.localStorage.getItem('userid');
    console.log('增添权限userId的值=', this.userId);
    this.getCompanyUserList()
  },
  methods: {
    //获取全部人员
    getAll() {
      this.nameList = []
      this.getCompanyUserList();
    },
    //返回权限用户列表页面
    returnBack() {
      this.$emit('return');
    },
    clear(){
      this.getCompanyUserList();
    },
    // 获取此公司内所有邀请为用户的成员，已经调通
    getCompanyUserList() {
      if (!this.searchTxt) {
        this.nameList = []
      }
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        //role_type: 1,                                //代表这是用户
        companyId: this.companyId,//后面打开
        nickname: this.searchTxt
      }

      this.$axiosRequest({
        url: API.getAllDeveloperOfCompany,                  //之后修改
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.nameList = res.data["userList"];
        }
      });
    },
    handleAddMemberForPermission(){
      let item = this.addMemberForPermissionItem;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        productUserId: item.userId,//选中的用户，而非登录的用户
        productId: this.productId,
      }
      this.$axiosRequest({
        url: API.insertProductUser,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data)
          if (res.data > 0) {
            this.$message({
              message: '添加成功',
              type: 'success',
            });
            this.addMemberForPermissionDialogVisible = false;
            this.$emit("return");
          } else if (res.data == 0) {
            this.$message({
              message: '用户已经存在分配页面',
              type: 'warning',
            });
            return;
          } else if (res.data == -3) {
            this.$message({
              message: '不存在公司用户关系',
              type: 'warning',
            });
            return;
          } else if (res.data == -2) {
            this.$message({
              message: '参数出错',
              type: 'warning',
            });
            return;
          } else if (res.data == -1) {
            this.$message({
              message: '程序出错',
              type: 'warning',
            });
            return;
          }
        }
      })
    },
    //增加可读权限,已经调通
    addMemberForPermission(item) {
      this.addMemberForPermissionDialogVisible = true;
      this.addMemberForPermissionItem = item;
    }
  },
}
</script>

<style>
.info-card {
  margin: 10px 15px 10px 15px;
  padding: 12px;
  background-color: #ffffff;
}

.button-group-card2 {
  padding: 12px;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed
}

.button-group-title2 {
  font-size: 18px;
  font-weight: bold;
  width: 450px;
  margin-left: 900px;
}
</style>




